import React from 'react';

import { fontFamily } from '../css-variables';

type TooltipComponentOption = Record<string, any>;

const baseTooltip: TooltipComponentOption = {
    appendToBody: true,
    backgroundColor: 'transparent',
    borderWidth: 0,
    className: 'metrics-chart-tooltip',
    confine: false,
    enterable: false,
    extraCssText: 'padding:0;box-shadow:none;pointer-events:none;',
    hideDelay: 50,
    renderMode: 'html',
    showDelay: 0,
    textStyle: {
        color: '#263238',
        fontFamily,
        fontSize: 12
    },
    transitionDuration: 0,
    trigger: 'item'
};

export const usePortalTooltip = (config: TooltipComponentOption, deps: React.DependencyList = []) => {
    return React.useMemo<TooltipComponentOption>(() => {
        return {
            ...baseTooltip,
            ...config,
            textStyle: {
                ...baseTooltip.textStyle,
                ...(config.textStyle ?? {})
            }
        };
    }, deps);
};
